import { Mic, MicOff, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useVoiceControl } from '@/contexts/VoiceControlContext';

export function VoiceControlToggle() {
  const { connect, disconnect, status, isConnecting } = useVoiceControl();

  const isConnected = status === 'connected';

  const handleClick = () => {
    if (isConnected) {
      disconnect();
    } else {
      connect();
    }
  };

  const label = isConnecting
    ? 'Connecting voice control...'
    : isConnected
      ? 'Disable voice control'
      : 'Enable voice control';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9"
          onClick={handleClick}
          disabled={isConnecting}
          aria-label={label}
        >
          {isConnecting ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : isConnected ? (
            <Mic className="h-4 w-4 text-primary" />
          ) : (
            <MicOff className="h-4 w-4" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
